<template>
   <Servicio >
      <span slot="title">
         <i class="far fa-building" />
         Sistemas Empresariales
      </span>

      <div slot="contenido">
         <div class="resumen">
            <span>
               Controla y crece tu negocio con un Sistema ERP a la Medida.
            </span>
            <img src="../../../assets/Servicios/accountant-4008603_640.jpg"/>
         </div>
      </div>
   </Servicio>

</template>

<script>
   import Servicio from "../Servicio";
   export default {
      name: "Empresa",
      components: {Servicio}
   }
</script>

<style scoped>

</style>